import { ThemeToggle } from "components";
import useClientNotifications from "Hooks/useClientNotifications";
import useViewTransitionNavigate from "Hooks/useViewTransitionNavigate";
import {
  HiBars3BottomRight,
  HiOutlineBell,
  HiOutlineMagnifyingGlass,
} from "react-icons/hi2";
import "./Navbar.scss";
import { Link } from "react-router-dom";

export default function Navbar({ isOpen, toggle }) {
  const navigate = useViewTransitionNavigate();
  const { unreadCount, hasUnreadNotifications } = useClientNotifications();

  return (
    <div className="sticky top-0 z-30 px-3 pt-2">
      <nav className="portal-topbar h-16 rounded-[1.75rem]">
        <div className="flex h-full flex-row-reverse items-center justify-between gap-3 px-4">
          <div
            onClick={() => navigate("/control-panel")}
            className="flex cursor-pointer items-center gap-3"
          >
            <div className="hidden flex-col text-right sm:flex">
              <span className="text-sm font-semibold portal-accent">
                لوحة الزبون
              </span>
              <span
                className="text-xs"
                style={{ color: "var(--layout-text-muted)" }}
              >
                SHAM
              </span>
            </div>
            <img
              className="w-12 drop-shadow-lg"
              src="/assets/images/clientLogo.png"
              alt="شعار SHAM"
            />
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/control-panel/notifications"
              className={`portal-outline-button relative inline-flex h-10 w-10 items-center justify-center rounded-xl p-2 text-sm duration-300 ${
                hasUnreadNotifications ? "client-notification-bell is-active" : ""
              }`}
              aria-label="الإشعارات"
              title="الإشعارات"
            >
              <HiOutlineBell className="text-2xl" />
              {unreadCount > 0 ? (
                <span className="client-notification-count">
                  {unreadCount > 9 ? "9+" : unreadCount}
                </span>
              ) : null}
            </Link>

            <button
              onClick={() => toggle((prev) => !prev)}
              type="button"
              className="portal-outline-button inline-flex h-10 w-10 items-center justify-center rounded-xl p-2 text-sm duration-300 lg:hidden"
              aria-expanded={isOpen}
              aria-label={
                isOpen ? "إغلاق القائمة الجانبية" : "فتح القائمة الجانبية"
              }
            >
              <HiBars3BottomRight
                className={`text-2xl transition-transform duration-300 ${
                  isOpen ? "rotate-90" : ""
                }`}
              />
            </button>
            <ThemeToggle
              floating={false}
              sizeClassName="inline-flex h-10 w-10 rounded-xl p-0"
            />

            {/* <Account /> */}

            <Link
              to="/control-panel/search"
              className="portal-outline-button inline-flex h-10 w-fit items-center justify-center gap-2 rounded-xl px-3 py-2 text-sm duration-300"
            >
              <HiOutlineMagnifyingGlass className="text-2xl" />
            </Link>
          </div>
        </div>
      </nav>
    </div>
  );
}
